// get single payment method

import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PaymentMethod } from './types';

export default (makeCall: MakeCall) => (uuid: string) =>
  makeCall<PaymentMethod>('GET', `/api/v2/payment/method/pay-in/${uuid}`);
